export type KboFlowReadStateStorage = {
    getItem<T>(key: string): Promise<T | null>;
    setItem<T>(key: string, value: T): Promise<T>;
};

const storageKeyPrefix = "read-chat-ids";

export function getKboFlowReadStateKey(userId: string, organizationId: string) {
    return `${storageKeyPrefix}:${encodeURIComponent(
        userId,
    )}:${encodeURIComponent(organizationId)}`;
}

export function normalizeKboFlowReadChatIds(value: unknown): string[] {
    if (!Array.isArray(value)) return [];

    return [...new Set(value.filter((id): id is string => typeof id === "string"))];
}

export async function loadKboFlowReadChatIds(
    storage: KboFlowReadStateStorage,
    userId: string,
    organizationId: string,
) {
    return normalizeKboFlowReadChatIds(
        await storage.getItem<unknown>(
            getKboFlowReadStateKey(userId, organizationId),
        ),
    );
}

export async function saveKboFlowReadChatIds(
    storage: KboFlowReadStateStorage,
    userId: string,
    organizationId: string,
    chatIds: readonly string[],
) {
    await storage.setItem(
        getKboFlowReadStateKey(userId, organizationId),
        [...new Set(chatIds)],
    );
}
